import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { camelCase } from 'lodash'

import { Tooltip } from 'react-wot-bootstrap'
import BaseBonusInfoTable from 'components/BaseBonusInfoTable/BaseBonusInfoTable'
import { getReserveTableColumns } from 'components/BaseBonusInfoTable/columns.js'
import { FOOTER_RESERVES_NOTES } from 'components/BaseBonusInfoTable/translations'

import {
    BONUS_TYPE_MESSAGES,
    EXTRA_DESCRIPTIONS,
    HEADERS,
} from './constants.jsx'

import styles from './ConstructReserveTooltip.scss'

const ConstructReserveTooltip = ({ bonus, reserveType }) => {
    const minBonus = bonus.values[0]

    const tableTitle = minBonus.duration ?
        <span>{BONUS_TYPE_MESSAGES[bonus.type]}</span> :
        <span>{HEADERS[reserveType] || HEADERS.SINGLE_USAGE}</span>

    const tableColumns = getReserveTableColumns(reserveType, minBonus, bonus.type)

    return (
        <Tooltip id={reserveType} isWide>
            <BaseBonusInfoTable
                className={cx(styles.infoTable, styles[`infoTable__${camelCase(reserveType)}`])}
                key={reserveType}
                title={tableTitle}
                notice={EXTRA_DESCRIPTIONS[reserveType]}
                footer={FOOTER_RESERVES_NOTES[reserveType]}
                dataSource={bonus.values}
                columns={tableColumns}
            />
        </Tooltip>
    )
}

ConstructReserveTooltip.propTypes = {
    reserveType: PropTypes.string.isRequired,
    bonus: PropTypes.object.isRequired,
}

export default ConstructReserveTooltip



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructReserveTooltip/ConstructReserveTooltip.jsx